import { useContext } from "react";
import ButtonFormat from "../../shared/ButtonFormat/ButtonFormat";
import WebplaceContext from "../../../store/webplace-context";

import "./HeroImage.css";

const HeroImage = () => {
  const placeCtx = useContext(WebplaceContext).homeBanner;
  const stylesCtx = useContext(WebplaceContext).homeBanner.home_banner_styles;




  const splitString = (data, splitSign) => {
    return data.split(splitSign);
  };

  const heroTitle = splitString(placeCtx.title, "/");


  return (
    <div aria-label="conent-main-home-image">
      <div className="hero-img-wrapper" aria-label="content-banner-image" role="contentinfo">
        <div className="hero-img-title">
          <h1 aria-label="title">
            {placeCtx.title.length > 0 &&
              heroTitle.map((data) => {
                return (
                  <div
                    key={data}
                    style={{ color: stylesCtx.hero_image_text_color }}
                  >
                    {data}
                  </div>
                );
              })}
          </h1>
        </div>
        <div className="hero-img-content">
          <div className="btn-wrapper">
            <ButtonFormat
              btnSize={stylesCtx.banner_btn.btn_size}
              showArrow={stylesCtx.banner_btn.show_arrow}
              arrowAtStart={stylesCtx.banner_btn.arrow_at_start}
              arrowColor={stylesCtx.banner_btn.arrow_color}
              showBorder={stylesCtx.banner_btn.show_border}
              borderColor={stylesCtx.banner_btn.border_color}
              backgroundColor={stylesCtx.banner_btn.background_color}
              fontColor={stylesCtx.banner_btn.font_color}
              capitalizeText={stylesCtx.banner_btn.capitalize_text}
              btnText={placeCtx.button_text}
              url={placeCtx.url}
            />
          </div>
        </div>

      </div>

    </div>
  );
};

export default HeroImage;
